import { BaseItemStore } from "../../../core/BaseStore";
import type { BusinessTemplateModel } from "./BusinessTemplateModel";

export default class BusinessTemplatesStore extends BaseItemStore<BusinessTemplateModel> {}
